<script setup lang="ts">
import TheFooter from "@/components/TheFooter.vue";

const userStore = useUserStore();

// Register the to-teach worksheet import listener once at the layout level
// so the success flash + folder list refresh fire whenever an import job
// completes, regardless of which page the user is currently on. The handler
// no-ops for unrelated job actions, so users without the feature pay nothing.
useToTeachImportNotification();

type Props = {
  enableBgPattern?: boolean;
  enableBgWhite?: boolean;
  enableFooter?: boolean;
  // TODO: remove withMainMargin and use size prop only
  withMainMargin?: boolean;
  // TODO: remove small and use size prop only
  small?: boolean;
  size?: "sm" | "md" | "lg" | "full";
  miniFooter?: boolean;
  fullscreen?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  enableBgPattern: true,
  enableFooter: true,
  withMainMargin: true,
  size: "full",
  fullscreen: false,
});

// Pupils should see a minimal footer with only essential links
const shouldUseMiniFooter = computed(
  () => userStore.isPupil || props.miniFooter
);
</script>
<template>
  <div
    class="the-layout"
    :class="{
      'bg-white': enableBgWhite,
      pattern: enableBgPattern,
    }"
  >
    <slot name="aboveContainer"></slot>

    <div
      class="container main-padding-top main-padding-top--small-header"
      :class="[
        `max-width-${size}`,
        {
          'main-margin': withMainMargin,
          'with-footer--lg': enableFooter && $slots.aboveFooter,
          'with-footer': enableFooter,
          'max-width-sm': small,
          fullscreen: fullscreen,
        },
      ]"
    >
      <slot></slot>
    </div>
    <slot name="aboveFooter"></slot>
    <TheFooter
      v-if="enableFooter"
      :with-main-margin="withMainMargin"
      :mini="shouldUseMiniFooter"
    />
  </div>
</template>

<style lang="scss">
.the-layout {
  @media print {
    height: auto;
  }
}

.export-pdf .the-layout {
  height: auto;
}

.flex-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.fullscreen {
  width: 100% !important;
  max-width: none !important;
  min-height: auto !important;
  padding: 0 !important;
}
</style>
